export default {
  buttons: {
    create: 'Crea',
    update: 'Aggiorna',
    cancel: 'Annulla',
  },
  fields: {
    title: {
      label: 'Titolo',
      placeholder: 'Inserisci titolo',
    },
    description: {
      label: 'Descrizione',
      placeholder: 'Inserisci descrizione',
    },
    button_text: {
      label: 'Testo pulsante',
      placeholder: 'Inserisci testo pulsante',
    },
    button_url: {
      label: 'URL pulsante',
      placeholder: 'https://example.com',
    },
    image: {
      label: 'Immagine',
    },
  },
  title: 'Crea post',
};
